var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSquareIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16667 2.88889C9.16667 2.67411 9.34078 2.5 9.55556 2.5H13.1111C13.3259 2.5 13.5 2.67411 13.5 2.88889V6.38711C13.5 6.60189 13.3259 6.776 13.1111 6.776C12.8963 6.776 12.7222 6.60189 12.7222 6.38711V3.817L7.16162 9.28745C7.00851 9.43807 6.76229 9.43606 6.61166 9.28295C6.46104 9.12984 6.46305 8.88362 6.61616 8.733L12.1613 3.27778H9.55556C9.34078 3.27778 9.16667 3.10367 9.16667 2.88889ZM2.72781 5.1723C2.87367 5.02644 3.0715 4.9445 3.27778 4.9445H8.33333C8.54811 4.9445 8.72222 5.11861 8.72222 5.33339C8.72222 5.54816 8.54811 5.72228 8.33333 5.72228L3.27778 5.72228V12.7223H10.2778V7.66672C10.2778 7.45194 10.4519 7.27783 10.6667 7.27783C10.8814 7.27783 11.0556 7.45194 11.0556 7.66672V12.7223C11.0556 12.9286 10.9736 13.1264 10.8278 13.2722C10.6819 13.4181 10.4841 13.5001 10.2778 13.5001H3.27778C3.0715 13.5001 2.87367 13.4181 2.72781 13.2722C2.58194 13.1264 2.5 12.9286 2.5 12.7223V5.72228C2.5 5.516 2.58194 5.31817 2.72781 5.1723Z",
    fill: "#5B6F82",
    stroke: "#5B6F82",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareIcon);
export default __webpack_public_path__ + "static/media/arrowSquare-icon.4d9fe53f47240f02ce6723c28d97b627.svg";
export { ForwardRef as ReactComponent };